import Button from 'layout/atoms/Button';
import { useTranslation } from 'react-i18next';

export const AddTaskMultiPopup = (props: {
    tasksCount: number;
    addMultiTasks: () => void;
    addConcatenatedTasks: () => void;
}) => {
    const { t } = useTranslation();
    return (
        <div
            className={'multi-add-task-popup'}
            style={{
                position: 'absolute',
                top: '100%',
                left: '50%',
                display: 'flex',
                zIndex: 1000,
                flexDirection: 'column',
                border: '1px solid #ccc',
                borderRadius: 'var(--radius)',
                color: 'var(--text)',
                backgroundColor: 'var(--white)',
                transform: 'translate3d(-50%,0,0)',
            }}
        >
            <div
                style={{
                    margin: '8px',
                    paddingBottom: '8px',
                    fontWeight: 'bold',
                    borderBottom: '1px solid #ccc',
                }}
            >
                {t('TASK.MULTI_POPUP.QUESTION', { count: props.tasksCount })} <br />
                {t('TASK.MULTI_POPUP.OR_ONE_LONG')}
            </div>
            <Button onClick={props.addMultiTasks}>
                {t('TASK.MULTI_POPUP.ADD_MULTIPLE', { count: props.tasksCount })}
            </Button>
            <Button onClick={props.addConcatenatedTasks}>{t('TASK.MULTI_POPUP.ADD_ONE')}</Button>
        </div>
    );
};
